/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import AccountOrderTemplatesTile from './account-order-templates-tile';
import AccountOrderTemplatesTileView from './account-order-templates-tile.view';

export * from './account-order-templates-tile';
export * from './account-order-templates-tile.data';
export {
    IAccountOrderTemplatesTileConfig,
    IAccountOrderTemplatesTileProps,
    IAccountOrderTemplatesTileResources
} from './account-order-templates-tile.props.autogenerated';
export * from './account-order-templates-tile.view';

export { AccountOrderTemplatesTile, AccountOrderTemplatesTileView };
